module.exports = "/assets/site/images/logo.png?4a2f9debc19f8af69af375808a45137d";